import * as api from './index';

export function getCompanies(query) {
    const queryString = (new URLSearchParams(query)).toString();
    return api.get(`/companies?${queryString}`);
}

export function getCompany(companyId) {
    return api.get(`/companies/${companyId}`);
}

export async function getCompanyOwner(companyId) {
    return api.get(`/companies/${companyId}/owner`);
}

export function getCompanyOverview(companyId) {
    return api.get(`/companies/${companyId}/overview`);
}

export function getCompanyDashboard(companyId) {
    return api.get(`/companies/${companyId}/dashboard`);
}

export async function resetTrial(companyId) {
    return api.post(`/companies/${companyId}/resetTrial`);
}

export function updateCompanyPlan(companyId, plan) {
    return api.patch(`/companies/${companyId}/plan`, { plan });
}

export function updateCompany(companyId, payload) {
    return api.patch(`/companies/${companyId}`, payload);
}

export async function deleteCompany(companyId) {
    return api.del(`/companies/${companyId}`);
}

export function updateTicketCounter(companyId, payload) {
    return api.patch(`/companies/${companyId}/ticketCounter`, payload);
}

// Its own endpoint rather than updateCompany: the setting is manager-editable, and
// CompanyForm patches the whole company object, which would clobber it on every save.
export function updateDispatchNotificationChannels(companyId, dispatchNotificationChannels) {
    return api.patch(`/companies/${companyId}/dispatchNotifications`, {
        dispatchNotificationChannels,
    });
}